import { IAppState } from '../../redux';
import { EServiceId } from '../../redux/reducers';

/**
 *
 * Возвращает id выбранной карточки продвижения (топ, премиум или карточка ставки - платное или бесплатное)
 */
export function selectActiveServiceId(state: IAppState): EServiceId | null {
  return state.publishTerms.selectedServiceId;
}
